import { Box, CircularProgress } from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import BaseCard from '../../../components/Cards/Card';
import CustomEmailInput from '../../../components/EmailInput';
import CustomPasswordInput from "../../../components/PasswordInput";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import { BASE_URL } from '../../../components/BaseUrl';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials, setOtpData } from '../../../Redux/Slices/AuthSlice';
import { showToast } from "../../../Utlis/messageHandler";

const RuleRow = ({ ok, label, showError }) => {

  const textColor = ok
    ? '#16a34a' 
    : showError
      ? '#d32f2f'
      : '#64748b';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
      <span
        aria-hidden
        style={{
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 18,
          height: 18,
          borderRadius: '50%',
          border: ok ? 'none' : '2px solid #9aa4b2',
          background: ok ? '#22c55e' : 'transparent'
        }}
      >
        {ok ? (
          <span
            style={{
              width: 6,
              height: 10,
              borderRight: '2px solid #fff',
              borderBottom: '2px solid #fff',
              transform: 'rotate(45deg)',
            }}
          />
        ) : (
          <span style={{ position: 'relative', width: 10, height: 10 }}>
            <span
              style={{
                position: 'absolute',
                width: '100%',
                height: 2,
                background: showError ? '#d32f2f' : '#9aa4b2',
                transform: 'rotate(45deg)',
                top: '50%',
                left: 0,
                marginTop: -1,
              }}
            />
            <span
              style={{
                position: 'absolute',
                width: '100%',
                height: 2,
                background: showError ? '#d32f2f' : '#9aa4b2',
                transform: 'rotate(-45deg)',
                top: '50%',
                left: 0,
                marginTop: -1,
              }}
            />
          </span>
        )}
      </span>
      <span style={{ fontSize: 14, color: textColor }}>{label}</span>
    </Box>
  );
};
/* -------------------- PASSWORD CHECKLIST --------------------- */
const PasswordChecklist = ({ password, showError }) => {
     const { t } = useTranslation();
  const rules = useMemo(() => ({
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*()[\]{}\-_+=~`|:;"'<>,.?/\\]/.test(password),
  }), [password]);

  return (
<Box sx={{ mt: 1, mb: { xs: 2, sm: 1.5 } }}>
  <RuleRow ok={rules.length} label={t('passwordRules.minLength')} showError={showError && !rules.length}/>
  <RuleRow ok={rules.upper} label={t('passwordRules.upperCase')} showError={showError && !rules.upper}/>
  <RuleRow ok={rules.lower} label={t('passwordRules.lowerCase')} showError={showError && !rules.lower}/>
  <RuleRow ok={rules.number} label={t('passwordRules.number')} showError={showError && !rules.number}/>
  <RuleRow ok={rules.special} label={t('passwordRules.special')} showError={showError && !rules.special}/>
</Box>
  );
};
/* -------------------- REGISTER --------------------- */
const Registeration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const profileUpdateToken =
    useSelector((s) => s.auth.profileUpdateToken) || localStorage.getItem("profileUpdateToken");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsError, setTermsError] = useState("");

  // validation function
  const validate = (values) => {
    const errors = {};

    // if (!values.firstName?.trim()) {
    //   errors.firstName = t("register.errors.firstNameRequired") || "First name is required";
    // }
    // if (!values.lastName?.trim()) {
    //   errors.lastName = t("register.errors.lastNameRequired") || "Last name is required";
    // }

    if (!values.email) {
      errors.email = t("register.errors.emailRequired") || "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = t("register.errors.emailInvalid") || "Invalid email address";
    }

    if (!values.confirmPassword) {
  errors.confirmPassword = t("register.errors.confirmPasswordRequired") || "Please confirm your password";
} else if (values.password !== values.confirmPassword) {
  errors.confirmPassword = t("register.errors.passwordMismatch") || "Passwords do not match";
}
    const pwd = values.password || "";
    const hasLen = pwd.length >= 8;
    const hasLower = /[a-z]/.test(pwd);
    const hasUpper = /[A-Z]/.test(pwd);
    const hasNum = /[0-9]/.test(pwd);
   const hasSpecial = /[!@#$%^&*()[\]{}\-_+=~`|:;"'<>,.?/\\]/.test(pwd);

    if (!pwd) {
      errors.password = t("register.errors.passwordRequired") || "Password is required";
    } else if (!(hasLen && hasLower && hasUpper && hasNum && hasSpecial)) {
      errors.password = t("register.errors.passwordInvalid") || "Password must meet all requirements.";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: { /* firstName: "", middleName: "", lastName: "", */ email: "", password: "" ,
       confirmPassword: ""
    },
    validate,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      const errors = validate(values);
      setTermsError("");
      if (Object.keys(errors).length > 0) {
        formik.setTouched({ email: true, password: true });
        const key = Object.keys(errors)[0];
        toast.error(errors[key]);
        return;
      }
      if (!acceptedTerms) {
        setTermsError(t('acceptTermsError') || "You must accept the Terms and Conditions");
        toast.error(t("acceptTermsError") || "You must accept the Terms and Conditions");
        return;
      }
      setIsSubmitting(true);
      try {
        const response = await fetch(`${BASE_URL}/account-executive/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: values.email,
            password: values.password,
            confirmPassword: values.password,
          }),
        });

        const data = await response.json();
        if (!response.ok || data.error)
          throw new Error(data.message || "Registration failed");

        const token = data.data.token;
        dispatch(setCredentials({ token, user: data.data.user }));
        dispatch(setOtpData({ otp: data.data.otp, userId: data.data.user.id }));

        showToast(toast.success, data, "Registration successful");

        setTimeout(() => navigate("/otp-screen"), 1000);
      } catch (err) {
        showToast(toast.error, err, t("Something went wrong"));
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  /* --------- helper for borders (touched + error) --------- */
  const isError = (name) => formik.touched[name] && formik.errors[name];

  return (
    <Box   sx={{
    backgroundColor: "#EFF4F8",
    pt: { xs:8, sm: 8 },   // top padding
    pb: { xs: 3, sm: 8 },   // bottom padding
  }}>
      <Box
        sx={{
          px: { xs: 1, sm: 2 },
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
          overflowY: "auto",
          alignItems: "center",
        }}
      >
        <BaseCard
          maxWidth={{ xs: "100%", sm: 500, md: 450 }}
          sx={{ 
            width: { xs: "100%", sm: "auto" }, 
            px: { xs: 2, sm: 3, md: 0 },
            mx: { xs: 1, sm: 0 },
            '@media (max-width: 768px)': {
              width: '100%',
              maxWidth: '100%',
              px: 2
            }
          }}
        >
          <form onSubmit={formik.handleSubmit} noValidate>
            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1.5, sm: 1 } }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, sm: 0.8 }, mb: { xs: 3, sm: 2 } }}>
                <CustomText
                  sx={{
                    ...textStyles.h4,
                    color: theme.palette.tertiary.main,
                    letterSpacing: "0px !important",
                  }}
                >
                  {t("register.title")}
                </CustomText>
                <CustomText
                  sx={{
                    ...textStyles.body4,
                    color: theme.palette.text.primary,
                    letterSpacing: "0px !important",
                  }}
                >
                  {t("register.subtitle")}
                </CustomText>
              </Box>
              <label style={{ marginTop: 5 }}>{t("register.emailLabel")}</label>
           <CustomEmailInput
  name="email"
  value={formik.values.email}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  error={formik.touched.email && Boolean(formik.errors.email)}
  helperText={formik.touched.email ? formik.errors.email : ""}
/>

              {/* Password */}
              <label style={{ marginTop: 5 }}>{t("register.passwordLabel")}</label>
            <CustomPasswordInput
           placeholder='********'
  name="password"
  value={formik.values.password}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  error={formik.touched.password && Boolean(formik.errors.password)}
  helperText={formik.touched.password ? formik.errors.password : ""}
/>

              {/* Checklist */}
             


<label style={{ marginTop: 5 }}>{t("register.confirmPasswordLabel")}</label>
<CustomPasswordInput
  name="confirmPassword"
  placeholder="********"
  value={formik.values.confirmPassword}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
  helperText={formik.touched.confirmPassword ? formik.errors.confirmPassword : ""}
/>
 <PasswordChecklist password={formik.values.password} />
  {/* Terms and Conditions Checkbox and Link */}
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1 }}>
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={acceptedTerms}
                  onChange={e => setAcceptedTerms(e.target.checked)}
                  style={{ marginRight: 8, width: 18, height: 18 }}
                  required
                />
                <span
  style={{
 color: "#1976D2",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: 14,
  }}
  onClick={() => window.open("https://biometricpro.app/terms", "_blank")}
>
  {t("termsAndConditionsText") || "I accept the Terms and Conditions"}
</span>

              </Box>
              {termsError && (
                <Box sx={{ color: '#d32f2f', fontSize: 13, mb: 1, ml: 0.5 }}>{termsError}</Box>
              )}
              <CustomButton
                label={
                  isSubmitting ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={18} sx={{ color: "#fff" }} />
                      <span>{t("register.continue")}</span>
                    </Box>
                  ) : (
                    t("register.continue")
                  )
                }
                type="submit"
                fullWidth
                disabled={!acceptedTerms || isSubmitting}
                sx={{ 
                  mt: { xs: 3, sm: 2 },
                  height: { xs: 48, sm: 44 },
                  fontSize: { xs: 16, sm: 14 },
                  opacity: !acceptedTerms ? 0.6 : 1,
                  cursor: !acceptedTerms ? 'not-allowed' : 'pointer',
                }}
              />
             
            </Box>
          </form>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default Registeration;















